import { gql } from '@lcs/shared/api';

export const getDepartmentNamesQuery = gql`
   query GetDepartmentNames($filtersDepartments: String, $after: String, $orderingOptions: [OrderingOption!]) {
      departmentsConnection(filters: $filtersDepartments, after: $after, orderingOptions: $orderingOptions) {
         items {
            departmentId
            name
         }
      }
   }
`;
